import React from "react";
import { css } from "emotion";
import TitleBlock from "../TitleBlock";
import TopRow from "../header/TopRow";
import headerShaded from "../../assets/images/header-shadow2.png";

const SettingsMobileHeader = () => {
  return (
    <div className={container}>
      <TopRow isSettings />
      <TitleBlock
        title="Settings"
        subtitle="It's all the little things that matter here."
      />
    </div>
  );
};

export default SettingsMobileHeader;

const container = css`
  padding-bottom: 30px;
  background-image: url(${headerShaded});
  background-position: center bottom;
  min-height: 230px;
  background-repeat: no-repeat;
  background-size: 100% auto;
`;
